var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.125,
    y: 0.125,
    width: 13.75,
    height: 13.75,
    rx: 6.875,
    fill: "#344151"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22673 9.01243V8.97228C7.24027 8.14914 7.45685 7.78776 8.05245 7.42639C8.64805 7.06501 9 6.54971 9 5.80688C9 4.76291 8.22166 4 7.02369 4C5.92724 4 5.04738 4.66922 5 5.81358H5.8731C5.92724 5.03729 6.47547 4.71606 7.02369 4.71606C7.65313 4.71606 8.16074 5.12428 8.16074 5.77342C8.16074 6.3021 7.85618 6.67686 7.45685 6.91778C6.80034 7.31262 6.40778 7.70076 6.39425 8.97228V9.01243H7.22673ZM6.84095 11C7.17936 11 7.45685 10.7256 7.45685 10.391C7.45685 10.0564 7.17936 9.78203 6.84095 9.78203C6.50254 9.78203 6.21827 10.0564 6.22504 10.391C6.21827 10.7256 6.50254 11 6.84095 11Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question_icon.04a677e7c0a32978615470283fbc40df.svg";
export { ForwardRef as ReactComponent };